var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFttIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 882.2 882.2",
    style: {
      enableBackground: "new 0 0 882.2 882.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5DC7D9;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 441.1,
    cy: 441.1,
    r: 440.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000019665476297255273060000010086367667617876668_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2_00000139272173998507135270000015007115515759065247_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.5,223.8c132.7,0,265.4,0,398.2,0c0,42.9,0,85.8,0,128.7c-132.7,0-265.4,0-398.2,0 C320.4,309.5,320.4,266.6,320.5,223.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.7,400.8c42.8-0.2,85.6-0.2,128.5,0c0.2,42.8,0.2,85.6,0,128.5c-42.8,0.2-85.7,0.2-128.5,0 C163.5,486.5,163.5,443.7,163.7,400.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.6,400.8c95.8-0.2,191.6-0.2,287.4,0c0.2,42.8,0.2,85.6,0,128.5c-95.8,0.2-191.6,0.2-287.4,0 C320.4,486.5,320.4,443.7,320.6,400.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.7,578c42.7-0.5,85.5-0.5,128.2,0c0.4,42.7,0.5,85.5,0,128.2c-42.7,0.4-85.5,0.4-128.2,0 C320.3,663.4,320.3,620.7,320.7,578z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFttIcon);
export default __webpack_public_path__ + "static/media/ftt_icon.3ffb49806c607404ab08b54c91aa3cfd.svg";
export { ForwardRef as ReactComponent };